export default {
  addMember: 'Agregar participante',
  cancel: 'Cancelar',
  submit: 'Agregar',
  searchByEmailOrName: 'Buscar por Nombre o Correo Electrónico'
}

export const en = {
  addMember: 'Add participant',
  cancel: 'Cancel',
  submit: 'Add',
  searchPlaceholder: 'Search by Name or Email'
}

export const ca = {
  addMember: 'Afegir participant',
  cancel: 'Cancelar',
  submit: 'Afegir',
  searchPlaceholder: 'Buscar per Nom o Correu Electrònic'
}
